/* eslint-disable no-restricted-imports */
import type { PropsWithChildren } from 'react';
import React, { createContext } from 'react';

import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import type { Logger } from '@feature-hub/logger';
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import type { AudiVideoServiceInterfaceV1 } from '@oneaudi/video-service';
import type { OneGraphServiceV1 } from '@oneaudi/onegraph-service';
import type { NumberFormatterService } from '@oneaudi/number-formatter-service';
import type { I18NServiceV1 } from '@oneaudi/i18n-service';
import type { GfaServiceConfigLike, AcsResult } from '@oneaudi/feature-app-utils';

interface FeatureAppEnv {
  featureAppId: string;
  featureAppName?: string;
}

export interface ContextState {
  readonly featureAppEnv: FeatureAppEnv;
  readonly numberFormatterService: NumberFormatterService;
  readonly localeService?: LocaleServiceV1;
  readonly loggerService?: Logger;
  readonly trackingService?: TrackingServiceV2;
  readonly videoService?: AudiVideoServiceInterfaceV1;
  readonly oneGraphService?: OneGraphServiceV1;
  readonly i18nService: I18NServiceV1;
  readonly gfaServiceConfigProvider?: GfaServiceConfigLike;
  readonly acsResult?: AcsResult;
}

export const Context = createContext<ContextState>({} as ContextState);

export interface ContextProviderProps {
  readonly featureAppEnv: FeatureAppEnv;
  readonly numberFormatterService: NumberFormatterService;
  readonly localeService?: LocaleServiceV1;
  readonly loggerService?: Logger;
  readonly trackingService?: TrackingServiceV2;
  readonly videoService?: AudiVideoServiceInterfaceV1;
  readonly oneGraphService?: OneGraphServiceV1;
  readonly i18nService: I18NServiceV1;
  readonly gfaServiceConfigProvider?: GfaServiceConfigLike;
  readonly acsResult?: AcsResult;
}

const ContextProvider = ({
  children,
  featureAppEnv,
  localeService,
  loggerService: logger,
  trackingService,
  videoService,
  oneGraphService,
  numberFormatterService,
  i18nService,
  gfaServiceConfigProvider,
  acsResult,
}: PropsWithChildren<ContextProviderProps>) => {
  const value = {
    featureAppEnv,
    localeService,
    loggerService: logger,
    trackingService,
    videoService,
    oneGraphService,
    numberFormatterService,
    i18nService,
    gfaServiceConfigProvider,
    acsResult,
  };

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
export default ContextProvider;
